<template>
    <b-modal
      id="modal-edit-message"
      title="Edit Message"
      ok-title="Save"
      cancel-variant="outline-secondary"
      @ok="handleEdit"
      centered
    >
      <b-form>
        <b-form-group label="Name">
          <b-form-input
            v-model="messageData.name"
            placeholder="Enter name"
          />
        </b-form-group>
  
        <b-form-group label="Email">
          <b-form-input
            v-model="messageData.email"
            placeholder="Enter email"
          />
        </b-form-group>
  
        <b-form-group label="Message">
          <b-form-textarea
            v-model="messageData.message"
            placeholder="Enter message"
            rows="3"
          />
        </b-form-group>
  
        <b-form-group label="Remark">
          <b-form-textarea
            v-model="messageData.remark"
            placeholder="Enter remark"
            rows="2"
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </template>
  
  <script>
  import {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea
  } from 'bootstrap-vue'
  import store from '@/store'
  
  export default {
    components: {
      BModal,
      BForm, 
      BFormGroup,
      BFormInput,
      BFormTextarea
    },
    props: {
      message: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        messageData: {
          id: 0,
          name: '',
          email: '',
          message: '',
          remark: ''
        }
      }
    },
    watch: {
      message: {
        handler(newVal) {
          this.messageData = {...newVal}
        },
        immediate: true
      }
    },
    methods: {
      handleEdit(bvModalEvent) {
        bvModalEvent.preventDefault()
        
        store.dispatch('bar-message/updateMessage', this.messageData)
          .then(response => {
            this.$emit('success', response.data.message)
            this.$bvModal.hide('modal-edit-message')
          })
          .catch(error => {
            this.$emit('error', error.response.data.message)
          })
      }
    }
  }
  </script>